import { render, staticRenderFns } from "./builderMenuBar.vue?vue&type=template&id=60d92f45&"
import script from "./builderMenuBar.vue?vue&type=script&lang=js&"
export * from "./builderMenuBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports